import React from 'react';
import { useAttributeFormBuilder, useAttributes } from '../../../../Hooks/Display/useComponentProperties';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';
import ColumnHyperlink from './ColumnHyperlink';
import ColumnColorFormatting from './ColumnColorFormatting';
import { useTranslation } from 'react-i18next';

const ColumnHeader = ({ column }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [{ steps }, dispatch] = useAttributeFormBuilder();
    const selectedComponent = useSelectedComponent();
    const [{ attributes }] = useAttributes();
    const attribute = attributes.find((attr) => attr._id === column.attributeId);
    const shouldColumnHyperlink = selectedComponent.componentType === "View" && attribute.attributeType === "Entity Lookup";
    const shouldColumnColorFormatting = selectedComponent.componentType === "View"

    const handleRemoveColumn = () => {
        dispatch.removeColumn(column.attributeId);
    };

    return (
        <div className='d-flex justify-content-end'>
            {shouldColumnHyperlink && <ColumnHyperlink column={column} />}
            {shouldColumnColorFormatting && <ColumnColorFormatting column={column} />}
            <button
                title={t("column.title.remove_column", { ns: "display/components/form" })}
                className='btn btn-sm btn-link'
                onClick={handleRemoveColumn}
            >
                <i className="fa-regular fa-trash text-danger"></i>
            </button>
        </div>
    );
};

export default ColumnHeader;